import _ from 'lodash'
import _fp from 'lodash/fp'

globalThis._ = _

export {_fp, _}
export default _
